var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xs-12 col-md-4 col-lg-4 col-xl-3 d-none d-xl-block" },
    [
      _c("ul", { staticClass: "m-profileMenu" }, [
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "profil" } } }, [
              _c("span", { staticClass: "icon --profile" }),
              _vm._v("Náš profil\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "kravicky" } } }, [
              _c("span", { staticClass: "icon --cows" }),
              _vm._v("Naša kravička\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.profil.pouzivatel_id &&
        _vm.profil.pouzivatel_id.pouzivatel_group === 1
          ? _c(
              "li",
              { staticClass: "a-profileMenu__item" },
              [
                _c("router-link", { attrs: { to: "/skoly" } }, [
                  _c("span", { staticClass: "icon --bag" }),
                  _vm._v("Školská sekcia\n            ")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.profil &&
        _vm.profil.pouzivatel_id &&
        _vm.profil.pouzivatel_id.pouzivatel_group === 0 &&
        _vm.profil.pouzivatel_id.farma_pouzivatela.length != 0
          ? _c("li", { staticClass: "a-profileMenu__item" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.adoptujkravicku.sk/hra/farma/moja-farma?" +
                      _vm.profil.pouzivatel_id.id +
                      "&" +
                      _vm.profil.pouzivatel_id.pouzivatel_name +
                      "&" +
                      _vm.profil.pouzivatel_email
                  }
                },
                [
                  _c("span", { staticClass: "icon --farm" }),
                  _vm._v("Moja farma\n            ")
                ]
              )
            ])
          : _vm.profil.pouzivatel_id.pouzivatel_group === 0
          ? _c(
              "li",
              { staticClass: "a-profileMenu__item" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "vytvorenie-farmy" } } },
                  [
                    _c("span", { staticClass: "icon --farm" }),
                    _vm._v("Moja farma\n            ")
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "aktivita" } } }, [
              _c("span", { staticClass: "icon --activity" }),
              _vm._v("Moja aktivita\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "album" } } }, [
              _c("span", { staticClass: "icon --stickers" }),
              _vm._v("Náš album\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "statistiky" } } }, [
              _c("span", { staticClass: "icon --stats" }),
              _vm._v("Štatistiky\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "spravy" } } }, [
              _c("span", { staticClass: "icon --messages" }),
              _vm._v("Správy\n                "),
              typeof _vm.spravy !== "undefined"
                ? _c("span", { staticClass: "badge" }, [
                    _vm._v(_vm._s(_vm.spravy))
                  ])
                : _c("span", { staticClass: "badge" }, [_vm._v("0")])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "heslo" } } }, [
              _c("span", { staticClass: "icon --password" }),
              _vm._v("Zmena hesla\n            ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "a-profileMenu__item" },
          [
            _c("router-link", { attrs: { to: { name: "udaje" } } }, [
              _c("span", { staticClass: "icon --userData" }),
              _vm._v("Moje údaje\n            ")
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "signOut",
          attrs: { to: { name: "login", params: { reset: true } } }
        },
        [_vm._v("\n        Odhlásiť sa "), _c("span", { staticClass: "icon" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }